import * as React from "react";

const DownloadIcon = ({ color = "#596375", ...props }: React.SVGProps<SVGSVGElement> & { color?: string }) => (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M10.1018 12.8634L10.1018 2.82922" stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.5317 10.4236L10.1017 12.8636L7.67174 10.4236" stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13.9626 6.77332H14.7401C16.4359 6.77332 17.8101 8.14748 17.8101 9.84415V13.9141C17.8101 15.6058 16.4392 16.9766 14.7476 16.9766H5.46423C3.76839 16.9766 2.39339 15.6016 2.39339 13.9058L2.39339 9.83498C2.39339 8.14415 3.76506 6.77332 5.45589 6.77332L6.24089 6.77332" stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default DownloadIcon; 